import { useAuthentication } from '@infominds/react-native-license'
import * as React from 'react'

import api from '../apis/Api'
import { PdfViewer } from '../components/PdfViewer/PdfViewer'
import useDisableBottomNavigation from '../hooks/useDisableBottomNavigation'
import { PreviewScreenNavigationProp } from '../types'

export default function PreviewScreen({ route }: PreviewScreenNavigationProp) {
  useDisableBottomNavigation(true)
  const { url, token, company } = useAuthentication()

  const { bill } = route.params

  return <PdfViewer load={() => api.getFile(token, url, company, bill.billID, bill.supplierID, bill.billDate)} />
}
